<template><section><template>
<h3>ProgressBar</h3>
<div class="bs-docs-section">
<blockquote>
<p>Height</p>
</blockquote>
<div class="bs-example">
  <div class="row">
    <div class="col-md-4">
      <n3-progress class="margin">
        <n3-progressbar :now="20" type="success" height="10px"></n3-progressbar>
      </n3-progress>
    </div>
    <div class="col-md-4">
      <n3-progress class="margin">
        <n3-progressbar :now="40" type="success"></n3-progressbar>
      </n3-progress>
    </div>
  </div>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-progress</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"margin"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"20"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span> <span class="hljs-attr">height</span>=<span class="hljs-string">"10px"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-progress</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-progress</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"margin"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-progress</span>&gt;</span>
</code></pre>
<blockquote>
<p>Dynamic <n3-button @click.native="dynamicClick">Random change</n3-button></p>
</blockquote>
<div class="bs-example">
  <n3-progress class="margin">
    <n3-progressbar :now="dynamicData[0] * 2" type="info"></n3-progressbar>
    </n3-progress>
    <n3-progress class="margin">
    <n3-progressbar :now="dynamicData[1] * 2" type="warning"></n3-progressbar>
    </n3-progress>
    <n3-progress class="margin">
    <n3-progressbar :now="dynamicData[2] * 2" type="danger"></n3-progressbar>
    </n3-progress>
    <n3-progress>
    <n3-progressbar :now="dynamicData[3] * 2" type="success" striped=""></n3-progressbar>
  </n3-progress>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-progress</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"margin"</span> &gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"dynamicData[0] * 2"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"info"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-progress</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progress</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"margin"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"dynamicData[1] * 2"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warning"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-progress</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progress</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"margin"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"dynamicData[2] * 2"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-progress</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"margin"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progress</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"dynamicData[3] * 2"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span> <span class="hljs-attr">striped</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-progress</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">dynamicData</span>: [<span class="hljs-number">5</span>, <span class="hljs-number">15</span>, <span class="hljs-number">25</span>, <span class="hljs-number">35</span>, <span class="hljs-number">45</span>]
    }
  },
  <span class="hljs-attr">methods</span>: {
    dynamicClick () {
      <span class="hljs-keyword">this</span>.dynamicData = <span class="hljs-keyword">this</span>.dynamicData.map(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
        <span class="hljs-keyword">return</span> <span class="hljs-built_in">Math</span>.floor(<span class="hljs-built_in">Math</span>.random() * <span class="hljs-number">50</span>)
      })
    }
  }
}
</code></pre>
<blockquote>
<p>Superimposed <n3-button @click.native="stackedClick">Random change</n3-button></p>
</blockquote>
<div class="bs-example">
  <n3-progress>
    <n3-progressbar :now="stackedData[0]" label="" type="warning" striped=""></n3-progressbar>
    <n3-progressbar :now="stackedData[1]" label="" type="success"></n3-progressbar>
    <n3-progressbar :now="stackedData[2]" label="" type="danger"></n3-progressbar>
    <n3-progressbar :now="stackedData[3]" label="" type="primary" striped="">
  </n3-progressbar>
</n3-progress></div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-progress</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"stackedData[0]"</span> <span class="hljs-attr">label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warning"</span> <span class="hljs-attr">striped</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"stackedData[1]"</span> <span class="hljs-attr">label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"success"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"stackedData[2]"</span> <span class="hljs-attr">label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-progressbar</span> <span class="hljs-attr">:now</span>=<span class="hljs-string">"stackedData[3]"</span> <span class="hljs-attr">label</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">striped</span> &gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-progressbar</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">stackedData</span>: [<span class="hljs-number">10</span>, <span class="hljs-number">20</span>, <span class="hljs-number">30</span>, <span class="hljs-number">40</span>]
    }
  },
  <span class="hljs-attr">methods</span>: {
    stackedClick () {
      <span class="hljs-keyword">let</span> i = <span class="hljs-number">100</span>
      <span class="hljs-keyword">this</span>.stackedData = <span class="hljs-keyword">this</span>.stackedData.map(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
        <span class="hljs-keyword">const</span> random = <span class="hljs-built_in">Math</span>.floor(<span class="hljs-built_in">Math</span>.random() * i)
        i = i - random
        <span class="hljs-keyword">return</span> random
      })
    }
  }
}
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>now</td>
<td><code v-pre="">Number</code></td>
<td></td>
<td>current value</td>
</tr>
<tr>
<td>height</td>
<td><code v-pre="">String</code></td>
<td>20px</td>
<td>height</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>color</td>
</tr>
<tr>
<td>label</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>label tip</td>
</tr>
<tr>
<td>striped</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>striped</td>
</tr>
<tr>
<td>animated</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>animated style</td>
</tr>
</tbody>
</table>
</div>
</template>


</section></template>
<style scoped>
.margin{
  margin-bottom:20px;
}

</style>
<script>
export default {
  data () {
    return {
      dynamicData: [5, 15, 25, 35, 45],
      stackedData: [10, 20, 30, 40]
    }
  },
  methods: {
    dynamicClick () {
      this.dynamicData = this.dynamicData.map(() => {
        return Math.floor(Math.random() * 50)
      })
    },
    stackedClick () {
      let i = 100
      this.stackedData = this.stackedData.map(() => {
        const random = Math.floor(Math.random() * i)
        i = i - random
        return random
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3ProgressbarDocs.md?80563f58